import BankIcon from "./bank-icon";
import CloseIcon from "./close-icon";
import CreditCardIcon from "./credit-card-icon";
import DocumentIcon from "./document-icon";
import EditIcon from "./edit-icon";
import MeterIcon from "./meter-icon";
import OpeningTimesIcon from "./opening-times-icon";
import Push from "./push";
import Search from "./search";
import ShopBagIcon from "./shop-bag-icon";
import ShopIcon from "./shop-icon";
import SupportIcon from "./support-icon";
import ThumbsupIcon from "./thumbsup-icon";

export const ICONS = {
    Push: Push,
    CreditCard: CreditCardIcon,
    Document: DocumentIcon,
    OpeningTimes: OpeningTimesIcon,
    Support: SupportIcon,
    Shop: ShopIcon,
    Close: CloseIcon,
    Bank: BankIcon,
    Edit: EditIcon,
    Search: Search,
    ShopBag: ShopBagIcon,
    Meter: MeterIcon,
    Thumbsup: ThumbsupIcon,
} as const;
export type ICON = typeof ICONS[keyof typeof ICONS];
